import { StateCreator } from "zustand";

import { sliceResetFns } from "store/utils";
import { Organization, Workspace } from "types";
import { CombinedSlice } from "store/types";

const MAX_USED_COLORS = 8;
interface LayoutSettings {
  usedColors: string[];
}

export type AppState = {
  organization?: Organization;
  workspace?: Workspace;
  layoutSettings: LayoutSettings;
};
export interface AppSlice {
  setAppState: (state: Partial<AppState>) => void;
  resetAppState: () => void;
  addUsedColor: (color: string) => void;
  appState: AppState;
}
const initialState = {
  organization: undefined,
  layoutSettings: {
    usedColors: [],
  },
};

export const createAppSlice: StateCreator<
  CombinedSlice,
  //https://github.com/pmndrs/zustand/issues/980#issuecomment-1162289836
  [
    ["zustand/devtools", never],
    ["zustand/persist", unknown],
    ["zustand/immer", never],
  ],
  [],
  AppSlice
> = (set) => {
  sliceResetFns.add(() => set({ appState: initialState }));
  return {
    appState: initialState,
    resetAppState: () => set({ appState: initialState }),
    setAppState: (newState) =>
      set((state) => ({
        appState: { ...state.appState, ...newState },
      })),
    addUsedColor: (color) =>
      set(({ appState }) => {
        const currentColors = appState.layoutSettings?.usedColors ?? [];
        const colorExists = currentColors.some(
          (existingColor) => existingColor.toLowerCase() === color.toLowerCase()
        );
        if (colorExists) return;
        currentColors.push(color);
        if (currentColors.length > MAX_USED_COLORS) {
          currentColors.shift(); // Remove first item
        }
        appState.layoutSettings = {
          ...appState.layoutSettings,
          usedColors: currentColors,
        };
      }),
  };
};
